import React from 'react';

import { nanoid } from 'nanoid';
import PropTypes from 'prop-types';

import { DateInput } from '~/components/inputs';

import { Container } from './styles';

function Date({
  label,
  error,
  errorMessage,
  isRelative,
  id = `_input${nanoid()}`,
  ...props
}) {
  return (
    <Container isRelative={isRelative}>
      <label className={error ? 'text-red-700 font-bold' : ''} htmlFor={id}>
        {label}
      </label>
      {error && (
        <span className="absolute top-2 right-0 text-xs text-red-600 ">
          {errorMessage}
        </span>
      )}
      <DateInput error={error} id={id} {...props} />
    </Container>
  );
}

Date.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  isRelative: PropTypes.bool,
};

Date.defaultProps = {
  error: false,
  isRelative: true,
  errorMessage: '',
};

export default Date;
